export interface Production {
  _id?: string;
  no: number | null;
  group: string | null;
  year: number;
  unit: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  total: number;
}

export interface MonthProduction {
  title: string;
  dataIndex: keyof Production;
}

export const MenuEditProduction = ["/production"];
